var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.6 511.6",
    style: {
      enableBackground: "new 0 0 511.6 511.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M370.336,244.281c0,2.451-1.983,4.435-4.435,4.435c-2.437,0-4.435-1.983-4.435-4.435 s1.998-4.434,4.435-4.434C368.353,239.848,370.336,241.83,370.336,244.281z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M370.336,244.281c0,2.451-1.983,4.435-4.435,4.435c-2.437,0-4.435-1.983-4.435-4.435 s1.998-4.434,4.435-4.434C368.353,239.848,370.336,241.83,370.336,244.281z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC87C0"
    },
    d: "M494.832,329.528l-0.75-0.219c-11.007-2.951-14.738-5.792-19.625-7.65 c-17.377-6.619-21.904-11.396-23.061-13.646c-0.047-0.094-0.078-0.172-0.109-0.249l-0.141-20.188l-32.35-0.469l-32.35,0.469 l-0.156,20.188c-0.031,0.077-0.062,0.155-0.094,0.249c-1.154,2.249-5.683,7.026-23.075,13.646c-4.902,1.858-8.618,4.699-19.61,7.65 l-0.764,0.219c-10.023,3.31-16.754,12.6-16.754,23.092v29.148h92.803H511.6V352.62C511.6,342.127,504.856,332.837,494.832,329.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M475.987,248.325c0,37.158-35.425,71.351-57.189,71.351s-57.205-34.192-57.205-71.351 c0-37.174,25.605-61.687,57.205-61.687C450.382,186.639,475.987,211.152,475.987,248.325z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6E51"
    },
    d: "M384.231,218.443c90.586-15.238,78.626,97.361,78.626,97.361 c39.345-33.271,21.546-133.583-21.889-140.608c-43.778-7.073-54.849,8.134-54.849,8.134L384.231,218.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6E51"
    },
    d: "M386.619,182.221c0,0-34.02,14.863-34.02,48.759c0,36.034,12.896,55.956,12.896,55.956 c0.406-53.036,23.216-69.414,23.216-69.414L386.619,182.221z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48CFAD"
    },
    d: "M186.635,329.512l-0.757-0.219c-11.007-2.951-14.73-5.792-19.633-7.65 c-17.385-6.619-21.905-11.396-23.061-13.661c-0.047-0.078-0.078-0.156-0.117-0.249l-0.141-20.188l-41.233-0.469l-41.226,0.469 l-0.141,20.188c-0.038,0.093-0.069,0.171-0.116,0.249c-1.155,2.265-5.676,7.042-23.061,13.661c-4.902,1.858-8.626,4.699-19.633,7.65 l-0.758,0.219C6.737,332.837,0,342.127,0,352.619v29.148h101.693h101.702v-29.148C203.396,342.127,196.658,332.837,186.635,329.512z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M158.907,248.466c0,37.174-35.441,71.382-57.214,71.382c-21.771,0-57.205-34.208-57.205-71.382 s25.613-61.687,57.205-61.687C133.294,186.779,158.907,211.292,158.907,248.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M131.226,189.981c0,0-1.108-9.883,10.733-17.003c5.02-3.013-75.176-17.299-95.301,33.365 c-7.564,19.047-1.975,47.057-1.975,47.057l17.432-31.241c0,0,18.993,4.434,39.578,4.434c20.586,0,40.273-4.434,40.273-4.434 l16.94,26.401c0,0,6.51-25.355-0.781-42.154C150.835,189.606,131.226,189.981,131.226,189.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M389.399,341.658l-1.015-0.312c-17.424-4.715-30.195-9.211-37.877-12.178 c-27.229-10.476-34.333-18.032-36.128-21.607c-0.062-0.125-0.125-0.266-0.188-0.391l-0.25-33.318l-116.322,1.344l-0.227,31.975 c-0.055,0.125-0.109,0.266-0.172,0.391c-1.812,3.575-8.899,11.132-36.136,21.623c-7.682,2.951-20.461,7.447-37.713,12.131 l-1.187,0.344c-15.698,5.246-26.261,19.969-26.261,36.565v46.183h319.734v-46.183C415.659,361.627,405.121,346.904,389.399,341.658z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DA4453"
    },
    points: "273.551,360.456 238.025,360.456 227.377,424.406 284.215,424.406 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED5564"
    },
    points: "273.551,360.456 238.025,360.456 223.818,303.828 287.776,303.828 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M346.385,213.009c0,58.876-56.111,115.473-90.593,115.473c-34.48,0-90.601-56.597-90.601-115.473 c0-58.86,40.562-97.704,90.601-97.704C305.823,115.305,346.385,154.149,346.385,213.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M314.16,104.656c-15.395-13.958-67.049-31.085-118.563,0c-26.089,15.737-45.082,85.262-45.082,85.262 s50.891,28.837,117.136-2.326c39.641-18.657,38.75-8.884,50.07,8.103c6.713,10.07,28.664,17.314,28.664,17.314 S363.465,149.278,314.16,104.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9573F"
    },
    d: "M396.19,176.944c-5.604,2.139-8.461,4.637-9.539,5.777l-0.031-0.5c0,0-6.4,2.795-13.661,8.743 c-0.687,11.085-0.327,25.168,3.31,39.797l2.171-0.546c4.418-7.588,8.587-11.335,9.867-12.382c2.404-0.312,4.73-0.53,6.979-0.655 C392.537,199.488,394.91,183.579,396.19,176.944z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam1);
export default __webpack_public_path__ + "static/media/team1.e77521eac51e10451cda0243a3928e8c.svg";
export { ForwardRef as ReactComponent };